import React, { useMemo } from 'react';
import axios from 'axios';
import { element } from 'prop-types';
import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import { ApiContext } from './context';

/**
 * Provider de API para o fluxo Keycloak (API v2).
 */
export const ApiProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const { i18n } = useTranslation();

  const baseURL = `${import.meta.env.VITE_API_URL}/api/v2`;

  const getApi = useMemo(() => {
    const headers = {
      'Accept-Language': i18n.language,
      locale: i18n.language,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    return () => {
      const config = {
        baseURL,
        headers: { ...headers },
      };
      if (keycloak?.token) {
        config.headers.Authorization = `Bearer ${keycloak.token}`;
      }
      return axios.create(config);
    };
  }, [keycloak?.token, i18n.language]);

  const value = useMemo(() => ({ getApi, baseURL }), [getApi, baseURL]);

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

ApiProvider.propTypes = {
  children: element.isRequired,
};
